module.exports = __webpack_public_path__ + "img/knu_gallery17.4a74eeaf.jpg";